import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttopunecitycab() {



  const cardData =
  {
    keyword: ' Mumbai Airport to Pune City Cab',
    heading: 'Sai Trupti Cabs: Mumbai Airport to Pune City Cab',
    headingDescription: 'Sai Trupti Cabs provides seamless and comfortable Mumbai Airport to Pune City cab services, ensuring that your journey is hassle-free from the moment you land. Our fleet of well-maintained, air-conditioned Sedans, SUVs and Luxury vehicles is ready for pickup from Chhatrapati Shivaji Maharaj International Airport (Mumbai) and drop-off at any preferred location within Pune. With experienced, background-verified chauffeurs, you can expect punctual arrivals, courteous service, and safe driving throughout the trip. We offer transparent fare structures, online booking, and 24×7 customer support, making your inter-city transfer smooth and stress-free. Choose Sai Trupti Cabs for reliable, safe and comfortable travel from Mumbai Airport to Pune City.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
    {
      "name": "Mumbai Airport to Pune City Cab",
      "description": "Reliable cab service from Mumbai Airport to Pune City offering spacious and comfortable vehicles for solo travelers, families, and groups. Professional drivers ensure safe, timely, and stress-free journeys. Ideal for business trips, leisure travel, or weekend getaways, this service includes AC and non-AC options, door-to-door pickup, well-maintained vehicles, real-time tracking, flexible scheduling, luggage assistance, and transparent fares for a completely hassle-free travel experience."
    },
    {
      "name": "Mumbai Airport to Pune City Taxi",
      "description": "Convenient taxi service from Mumbai Airport to Pune City with multiple vehicle options including Sedans, SUVs, and luxury cars. Suitable for one-way or round trips, this service ensures comfortable travel with AC and non-AC options, professional drivers, punctual pickups, flexible drop points, real-time ride tracking, safety protocols, and customer support for business commuters, families, and solo travelers."
    },
    {
      "name": "Mumbai Airport to Pune City Car Hire",
      "description": "Car hire service from Mumbai Airport to Pune City offering a range of vehicles including Sedans, SUVs, and luxury cars for personalized and long-distance travel. Perfect for business trips, family journeys, sightseeing tours, and pilgrimages, the service includes professional drivers, AC/non-AC options, customizable pickup and drop locations, toll-inclusive travel, and reliable, comfortable, and secure travel experience for every passenger."
    },
    {
      "name": "Mumbai Airport to Pune City Innova Cab",
      "description": "Travel from Mumbai Airport to Pune City in a spacious and comfortable Innova cab, perfect for families or small groups. The service includes AC vehicles, professional drivers, door-to-door pickup, luggage assistance, and flexible timings. Ideal for long-distance travel, sightseeing trips, business visits, and airport transfers, the Innova cab ensures a smooth, safe, and enjoyable journey with modern amenities and transparent pricing."
    },
    {
      "name": "Mumbai Airport to Pune City Ertiga Cab",
      "description": "Ertiga cab service from Mumbai Airport to Pune City providing comfortable seating for small to medium groups, AC service, and professional drivers. Suitable for family trips, leisure travel, sightseeing tours, and business commutes, this service guarantees safe, reliable, and stress-free transportation with options for one-way or round trips, real-time tracking, well-maintained vehicles, flexible scheduling, and convenient online booking."
    },
    {
      "name": "Mumbai Airport to Pune City Sedan Cab",
      "description": "Sedan cab service from Mumbai Airport to Pune City offering a smooth and comfortable ride for business travelers, couples, or solo passengers. Equipped with AC and optional luxury amenities, professional drivers ensure safe and timely travel. Perfect for airport transfers, city tours, corporate travel, and long-distance journeys, this service guarantees convenience, comfort, privacy, and hassle-free travel."
    },
    {
      "name": "Mumbai Airport to Pune City One Way Taxi",
      "description": "Affordable one-way taxi service from Mumbai Airport to Pune City designed for travelers seeking direct and efficient transport. Professional drivers provide punctual pickups, safe travel, luggage assistance, and comfortable AC or non-AC vehicles. Ideal for business trips, family visits, airport transfers, or leisure travel, this service ensures reliable, convenient, and stress-free transportation without unnecessary delays or detours."
    },
    {
      "name": "Mumbai Airport to Pune City Drop Cab",
      "description": "Drop cab service from Mumbai Airport to Pune City offering point-to-point travel with AC and non-AC options. Professional drivers ensure a safe, comfortable, and timely journey, perfect for long-distance travel, airport pickups, corporate trips, or leisure visits. Flexible drop points, well-maintained vehicles, transparent fare options, luggage handling, and real-time ride updates make it a convenient and reliable choice."
    },
    {
      "name": "Mumbai Airport to Pune City Luxury Cab",
      "description": "Premium luxury cab service from Mumbai Airport to Pune City with top-class vehicles, AC service, and professional chauffeurs. Perfect for business executives, couples, or families seeking a high-end, stress-free travel experience. The service offers door-to-door pickup, comfortable seating, optional amenities, luggage assistance, flexible scheduling, and an unmatched luxury travel experience with safety and punctuality."
    },
    {
      "name": "Mumbai Airport to Pune City Outstation Cab",
      "description": "Outstation cab service from Mumbai Airport to Pune City offering long-distance travel with comfortable vehicles, professional drivers, and safety-focused services. Includes tolls, driver allowances, luggage handling, and flexible pickup/drop locations. Ideal for families, groups, business trips, and leisure travelers, ensuring reliable, timely, and comfortable transport over extended distances with modern vehicles and customer support."
    },
    {
      "name": "Affordable Mumbai Airport to Pune City Cab",
      "description": "Budget-friendly cab service from Mumbai Airport to Pune City providing AC and non-AC options for cost-effective and comfortable travel. Professional drivers ensure punctuality, safety, and a smooth journey for families, groups, and solo travelers. Transparent fares, flexible bookings, luggage support, and reliable vehicles make it the perfect choice for affordable, hassle-free, and safe long-distance transport."
    },
    {
      "name": "Mumbai Airport to Pune City AC Cab",
      "description": "AC cab service from Mumbai Airport to Pune City offering a cool and comfortable journey with professional drivers, modern vehicles, and safe travel practices. Suitable for families, groups, or solo travelers, this service ensures a smooth and enjoyable ride with flexible pickup points, luggage assistance, punctual service, well-maintained cars, and door-to-door convenience."
    },
    {
      "name": "Mumbai Airport to Pune City Online Booking",
      "description": "Book your Mumbai Airport to Pune City cab online instantly with multiple vehicle options, secure payment methods, and transparent fares. Perfect for hassle-free one-way or round trips, this service offers professional drivers, real-time tracking, safe travel, luggage support, and flexible scheduling, making your long-distance journey convenient, comfortable, and reliable every time."
    },
    {
      "name": "Mumbai Airport to Pune City Travel Service",
      "description": "Comprehensive travel service from Mumbai Airport to Pune City including cabs, drop services, luxury options, luggage assistance, and professional drivers. Ideal for business travel, family trips, or leisure tours, this service ensures safe, comfortable, and stress-free transportation with well-maintained vehicles, flexible pickup/drop locations, real-time ride tracking, and excellent customer support throughout the journey."
    },
    {
      "name": "Mumbai Airport to Pune City Cab near Me",
      "description": "Find Mumbai Airport to Pune City cabs near your location for quick and convenient booking. Professional drivers, AC and luxury vehicle options, luggage assistance, and reliable services ensure a hassle-free journey for families, groups, or solo travelers. Door-to-door pickup, real-time tracking, flexible scheduling, and safe travel make it the most convenient choice for your trip."
    }
  ],
  "tableData": [
    ["Mumbai Airport to Pune City Cab", "Mumbai Airport to Pune City Taxi"],
    ["Mumbai Airport to Pune City Car Hire", "Mumbai Airport to Pune City Innova Cab"],
    ["Mumbai Airport to Pune City Ertiga Cab", "Mumbai Airport to Pune City Sedan Cab"],
    ["Mumbai Airport to Pune City One Way Taxi", "Mumbai Airport to Pune City Drop Cab"],
    ["Mumbai Airport to Pune City Luxury Cab", "Mumbai Airport to Pune City Outstation Cab"],
    ["Affordable Mumbai Airport to Pune City Cab", "Mumbai Airport to Pune City AC Cab"],
    ["Mumbai Airport to Pune City Online Booking", "Mumbai Airport to Pune City Travel Service"],
    ["Mumbai Airport to Pune City Cab near Me", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai Airport to Pune City Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Mumbai Airport to Pune City—ideal for business travel, airport pickups, or leisure trips."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our one‑way fares from Mumbai Airport to Pune start from approx. ₹2,200–₹3,700 depending on car type and service inclusions. :contentReference[oaicite:turn0search1]{index=1} :contentReference[oaicite:turn0search0]{index=1}"
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Mumbai Airport → Pune route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous, trained drivers are familiar with the Mumbai Airport → Pune route, ensuring a safe, smooth and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickup at Mumbai Airport (domestic or international terminal) and drop‑off at any location in Pune City including hotels, railway station or your residence."
  },
  {
    "WhyChooseheading": "Clean, Well‑Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and maintained to ensure comfort and reliability on the airport‑to‑city ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, flight schedule changes, route planning or any travel assistance."
  },
  {
    "WhyChooseheading": "Hassle‑Free Booking Process",
    "WhyChoosedescription": "Book your Mumbai Airport to Pune City cab easily via call, WhatsApp or our website—with instant confirmation and prompt dispatch."
  }
]
























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Mumbai Airport to Pune City cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable cab services from Mumbai Airport to Pune City for one way, round trip, and corporate travel.',
  },
  {
    question: 'How can I book a cab from Mumbai Airport to Pune City with Sai Trupti Cabs?',
    answer: 'You can easily book your Mumbai Airport to Pune City cab through our website, mobile app, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Mumbai Airport to Pune City?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and luxury cabs to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Mumbai Airport to Pune City trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire a cab from Mumbai Airport to Pune City for family or corporate trips?',
    answer: 'Certainly. Our cab services cater to family trips, group travel, and corporate transfers from Mumbai Airport to Pune City.',
  },
  {
    question: 'Is the Mumbai Airport to Pune City cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Mumbai Airport to Pune City for your convenience and flexible travel plans.',
  },
  {
    question: 'What are the Mumbai Airport to Pune City cab fares?',
    answer: 'Our cab fares start from ₹2,500 for sedans, ₹3,000–₹4,000 for SUVs and Innova Crysta, depending on vehicle type, group size, and travel requirements.',
  },
  {
    question: 'What payment options are accepted for Mumbai Airport to Pune City cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Mumbai Airport to Pune City cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during the Mumbai Airport to Pune City cab ride?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Mumbai Airport to Pune City cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshmukh',
    feedback: 'I booked a cab from Mumbai Airport to Pune City with Sai Trupti Cabs. The ride was comfortable and the driver was punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Patil',
    feedback: 'Sai Trupti Cabs provided excellent service for my Mumbai Airport to Pune City trip. Smooth journey and professional driver.',
    rating: 5,
  },
];

































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune City Cab",
  "image": "https://saitrupticabs.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book Mumbai Airport to Pune City Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15864"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/mumbai-airport-to-pune-city-cab"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai Airport to Pune City Cab | Safe & Comfortable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune City Cab with Sai Trupti Cabs for a safe, comfortable, and affordable journey. Choose AC sedans, SUVs, or Innova for one-way, round-trip, or outstation travel with verified drivers and 24/7 online booking." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune City Cab, Mumbai Airport to Pune City Taxi, Mumbai Airport to Pune City Car Hire, Mumbai Airport to Pune City Innova Cab, Mumbai Airport to Pune City Ertiga Cab, Mumbai Airport to Pune City Sedan Cab, Mumbai Airport to Pune City One Way Taxi, Mumbai Airport to Pune City Drop Cab, Mumbai Airport to Pune City Luxury Cab, Mumbai Airport to Pune City Outstation Cab, Affordable Mumbai Airport to Pune City Cab, Mumbai Airport to Pune City AC Cab, Mumbai Airport to Pune City Online Booking, Mumbai Airport to Pune City Travel Service, Mumbai Airport to Pune City Cab near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/newkey/1.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaiairporttopunecitycab;